export var PermissionArea;
(function (PermissionArea) {
    // SPECIAL PERMISSIONS
    PermissionArea["SPECIAL_IS_SYSTEM_OWNER"] = "SPECIAL_IS_SYSTEM_OWNER";
    PermissionArea["SPECIAL_IS_DEPARTMENT_OWNER"] = "SPECIAL_IS_DEPARTMENT_OWNER";
    PermissionArea["SPECIAL_IS_CLOUD_ACCOUNT_OWNER"] = "SPECIAL_IS_CLOUD_ACCOUNT_OWNER";
    PermissionArea["SPECIAL_IS_RESOURCE_OWNER"] = "SPECIAL_IS_RESOURCE_OWNER";
    // SPECIFIC PERMISSIONS
    PermissionArea["ALLOCATION_TAB"] = "ALLOCATION_TAB";
    PermissionArea["GLOBAL_BUDGET"] = "GLOBAL_BUDGET";
    PermissionArea["BUDGET_APPROVAL"] = "BUDGET_APPROVAL";
    PermissionArea["SMART_RECOMMENDATIONS"] = "SMART_RECOMMENDATIONS";
    PermissionArea["USER_MANAGEMENT"] = "USER_MANAGEMENT";
    PermissionArea["ADMIN_PANEL"] = "ADMIN_PANEL";
    PermissionArea["ACTION_CENTER_SPONSOR_CONFIG"] = "ACTION_CENTER_SPONSOR_CONFIG";
    PermissionArea["ACTION_CENTER_FILTER"] = "ACTION_CENTER_FILTER";
    PermissionArea["DEPARTMENT_BUDGET"] = "DEPARTMENT_BUDGET";
    PermissionArea["DEPARTMENT_BUDGET_VIEW_ALL"] = "DEPARTMENT_BUDGET_VIEW_ALL";
    PermissionArea["SYSTEM_CREATE"] = "SYSTEM_CREATE";
    PermissionArea["SYSTEM_EDIT"] = "SYSTEM_EDIT";
    PermissionArea["SYSTEM_BUDGET_SET"] = "SYSTEM_BUDGET_SET";
    PermissionArea["SYSTEM_VIEW_ALL"] = "SYSTEM_VIEW_ALL";
    PermissionArea["SYSTEM_VIEW_DEPARTMENT"] = "SYSTEM_VIEW_DEPARTMENT";
    PermissionArea["SYSTEM_VIEW_OWNED"] = "SYSTEM_VIEW_OWNED";
})(PermissionArea || (PermissionArea = {}));
